<div
    class="ev-sidebar"
    [style.top]="computedTop()"
    [style]="styles()"
    [class.position-right]="sidebarPosition() === 'right'"
    [class.position-left]="sidebarPosition() === 'left'"
    [class.visible]="visible()"
    [class.shadow-offset]="topPosition() !== 0"
>
    <ng-content></ng-content>
</div>
